module.exports = __webpack_public_path__ + "img/color_block_4.01e84d49.svg";